export function getApiBaseUrl(): string {
  const raw = (process.env.REACT_APP_API_BASE_URL ?? "").toString().trim();
  return raw.replace(/\/+$/, "");
}

export function apiUrl(path: string): string {
  const base = getApiBaseUrl();
  if (!base) return path;

  const p = path.startsWith("/") ? path : `/${path}`;
  return `${base}${p}`;
}
